import { render, staticRenderFns } from "./LeavePlanReviews.vue?vue&type=template&id=66db2eea&scoped=true"
import script from "./LeavePlanReviews.vue?vue&type=script&lang=js"
export * from "./LeavePlanReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66db2eea",
  null
  
)

export default component.exports